import './App.css';
import './styles/style.css'
import './i18n'; // Initialize i18n
import Header from './components/common/Header';
import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Navigation from './components/common/Navigation';
import DishesPage from './pages/DishesPage';
import IngredientPage from './pages/IngredientPage';
import PlanPage from './pages/PlanPage';
import RestaurantPage from './pages/RestaurantPage';
import ShoppingPage from './pages/ShoppingPage';
import TagManagementPage from './pages/TagManagementPage';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import InviteUser from './components/admin/InviteUser';
import AnalyticsPage from './pages/AnalyticsPage';

function App() {

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        window.dispatchEvent(new CustomEvent('openSearch'));
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <SnackbarProvider>
          <BrowserRouter>
            <div className="App">
              <ProtectedRoute>
                <Navigation />

              <Routes>
                <Route path="/" element={<Header />} />
                <Route path="/dishes" element={<DishesPage />} />
                <Route path="/ingredients" element={<IngredientPage />} />
                <Route path="/plans" element={<PlanPage />} />
                <Route path="/restaurants" element={<RestaurantPage />} />
                <Route path="/shopping" element={<ShoppingPage />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/tags" element={<TagManagementPage />} />
                <Route path="/invite" element={<InviteUser />} />
              </Routes>

              {/* REMOVE: GlobalSearch component (now in Navigation) */}
            </ProtectedRoute>
          </div>
        </BrowserRouter>
        </SnackbarProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
